import { ListValidationContext } from '@shopify/react-form/build/ts/types';

/**
 * This wrapper can be used on any form validator to skip if it the associated dynamic list item is marked as deleted
 */
export const validateIfNotDeleted = (
  validator: (
    input: string,
    context: ListValidationContext<Partial<{ deleted: { value: boolean } }>>
  ) => string
) => {
  return (value: string, { listItem, siblings }) => {
    if (listItem.deleted.value) {
      return;
    }

    return validator(value, { listItem, siblings });
  };
};
